import get11AgentInfo from '../ecdn11/get11AgentInfo';
import logger from '../log';
import racedPromise from '../common/utils/racedPromise';
import { BasePromiseData } from './interfaces';
import { addDuration } from '../common/utils/duration';
import { ElevenAgentData, ElevenDataRequestState } from '../ecdn11/interfaces';
import { getElevenData } from '../ecdn11/store11AgentInfo';

const log = logger.getLogger(__filename);
export type OptionalElevenData = ElevenAgentData | undefined;
const CONFIG_TIMEOUT = 10000;

// Rather than call the local agent twice to get information, store the
// promise between calls so they all get the same data.
let promise: Promise<OptionalElevenData>;

const get11Data = (obj: BasePromiseData): Promise<OptionalElevenData> => {
  const { base, config, vals, playGuid } = obj;
  // getElevenData returns NOTCALLED if playGuid is different.
  const data = getElevenData(playGuid);

  // If it's been less than a minute re-use the data
  if ((data.ts ?? 0) + CONFIG_TIMEOUT > Date.now()) {
    switch (data.state) {
      case ElevenDataRequestState.WAITING:
        if (typeof promise !== 'undefined') {
          return promise;
        }
        break;
      case ElevenDataRequestState.SUCCESS:
        if (data.data) {
          return Promise.resolve(data.data);
        }
        break;
      case ElevenDataRequestState.FAILED:
        return Promise.resolve(undefined);
    }
  }

  const controller = new AbortController();
  promise = racedPromise({
    ...base,
    callback: value => {
      log.debug('11 Agent finished: ', { value });
      addDuration({ vals, key: '11' });
    },
    controller,
    promise: get11AgentInfo(config, controller, playGuid)
  });
  return promise;
};

export default get11Data;
